








































































































































































































































































































































































































































import Vue from 'vue'
import PageTopButton from '@/components/howto/PageTopButton.vue'
import LetsStart from '@/components/howto/LetsStart.vue'
import ComposeButton from '@/components/howto/ComposeButton.vue'

export default Vue.extend({
  name: 'Guide',

  components: {
    'page-top-button': PageTopButton,
    'lets-start': LetsStart,
    'compose-button': ComposeButton,
  },

  mounted () {
    window.scrollTo(0, 0)
  },
})
